// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tauros_paldea_combat_breed: PokeData = {
  "id": 10250,
  "name": "tauros-paldea-combat-breed",
  "height": 14,
  "weight": 1150,
  "base_experience": 172,
  "types": [
    PokeType.FIGHTING
  ],
  "api_moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "thrash",
    "double-edge",
    "tail-whip",
    "rest",
    "scary-face",
    "swagger",
    "close-combat",
    "assurance",
    "zen-headbutt",
    "work-up",
    "raging-bull"
  ],
  "moves": [
    "double-kick",
    "headbutt",
    "tackle",
    "scary-face",
    "close-combat",
    "zen-headbutt",
    "karate-chop",
    "meteor-assault",
    "rolling-kick",
    "bulk-up",
    "drain-punch",
    "coaching",
    "jump-kick"
  ],
  "evolution_chain": {
    "id": 63,
    "item": null,
    "species": [
      {
        "name": "tauros",
        "order": 152,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 137,
    "ability_power": 151
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "paldea"
} as const;
